import ModalFooter from "./modal-footer";

export default ModalFooter;